import { useState } from 'react';
import P2GConditionalImage from '../P2GConditionalImage';
import { P2GFade, P2GBox, P2GGrid, P2GLink, P2GButton } from '@parcel2go/core-ui';

interface props {
  selectedCode?: string;
  onSelect: (code: string | undefined) => void;
  exit: () => void;
  children?: React.ReactNode;
}
const categories = [
  {
    CategoryCode: '1000',
    ParentCategoryCode: null,
    Description: 'Home, Furniture \u0026 DIY',
    TariffCode: '94039990',
    Icon: null,
    IconUrl:
      'https://content.parcelsolutions.net/42C5534B-0F47-4342-80F0-8F21203F0669/order-process/customs/icons/01-Home-Furniture-DIY.svg',
    SortOrder: 1
  },
  {
    CategoryCode: '2000',
    ParentCategoryCode: null,
    Description: 'Clothes, Shoes \u0026 Accessories',
    TariffCode: null,
    Icon: null,
    IconUrl:
      'https://content.parcelsolutions.net/42C5534B-0F47-4342-80F0-8F21203F0669/order-process/customs/icons/02-Clothes-Shoes-Accessories.svg',
    SortOrder: 2
  },
  {
    CategoryCode: '3000',
    ParentCategoryCode: null,
    Description: 'Toys \u0026 Games',
    TariffCode: '95030055',
    Icon: null,
    IconUrl:
      'https://content.parcelsolutions.net/42C5534B-0F47-4342-80F0-8F21203F0669/order-process/customs/icons/03-Toys-Games.svg',
    SortOrder: 3
  },
  {
    CategoryCode: '4000',
    ParentCategoryCode: null,
    Description: 'Art \u0026 Crafts',
    TariffCode: '49111090',
    Icon: null,
    IconUrl:
      'https://content.parcelsolutions.net/42C5534B-0F47-4342-80F0-8F21203F0669/order-process/customs/icons/04-Art-Crafts.svg',
    SortOrder: 4
  },
  {
    CategoryCode: '6000',
    ParentCategoryCode: null,
    Description: 'Books, Comics \u0026 Magazines',
    TariffCode: '49011000',
    Icon: null,
    IconUrl:
      'https://content.parcelsolutions.net/42C5534B-0F47-4342-80F0-8F21203F0669/order-process/customs/icons/06-Books-Comics-Magazines.svg',
    SortOrder: 6
  },
  {
    CategoryCode: '7000',
    ParentCategoryCode: null,
    Description: 'Health \u0026 Beauty',
    TariffCode: '33049900',
    Icon: null,
    IconUrl:
      'https://content.parcelsolutions.net/42C5534B-0F47-4342-80F0-8F21203F0669/order-process/customs/icons/07-Health-Beauty.svg',
    SortOrder: 7
  },
  {
    CategoryCode: '8000',
    ParentCategoryCode: null,
    Description: 'Musical',
    TariffCode: '85182900',
    Icon: null,
    IconUrl:
      'https://content.parcelsolutions.net/42C5534B-0F47-4342-80F0-8F21203F0669/order-process/customs/icons/08-Musical.svg',
    SortOrder: 8
  },
  {
    CategoryCode: '9000',
    ParentCategoryCode: null,
    Description: 'Video Games \u0026 Consoles',
    TariffCode: '95045000',
    Icon: null,
    IconUrl:
      'https://content.parcelsolutions.net/42C5534B-0F47-4342-80F0-8F21203F0669/order-process/customs/icons/09-Video-Games-Consoles.svg',
    SortOrder: 9
  },
  {
    CategoryCode: '10000',
    ParentCategoryCode: null,
    Description: 'Dolls \u0026 Bears',
    TariffCode: '95030021',
    Icon: null,
    IconUrl:
      'https://content.parcelsolutions.net/42C5534B-0F47-4342-80F0-8F21203F0669/order-process/customs/icons/10-Dolls-Bears.svg',
    SortOrder: 10
  },
  {
    CategoryCode: '11000',
    ParentCategoryCode: null,
    Description: 'Sporting Goods',
    TariffCode: '95069100',
    Icon: null,
    IconUrl:
      'https://content.parcelsolutions.net/42C5534B-0F47-4342-80F0-8F21203F0669/order-process/customs/icons/11-Sporting-Goods.svg',
    SortOrder: 11
  },
  {
    CategoryCode: '12000',
    ParentCategoryCode: null,
    Description: 'Collectables',
    TariffCode: '85238010',
    Icon: null,
    IconUrl:
      'https://content.parcelsolutions.net/42C5534B-0F47-4342-80F0-8F21203F0669/order-process/customs/icons/12-Collectables.svg',
    SortOrder: 12
  },
  {
    CategoryCode: '000',
    ParentCategoryCode: null,
    Description: 'Others',
    TariffCode: null,
    Icon: null,
    IconUrl:
      'https://content.parcelsolutions.net/42C5534B-0F47-4342-80F0-8F21203F0669/order-process/customs/icons/13-Other.svg',
    SortOrder: 13
  },
  {
    CategoryCode: '2100',
    ParentCategoryCode: '2000',
    Description: 'Men\u0027s Clothing',
    TariffCode: '62059080',
    Icon: null,
    IconUrl: null,
    SortOrder: 1
  },
  {
    CategoryCode: '2200',
    ParentCategoryCode: '2000',
    Description: 'Women\u0027s Clothing',
    TariffCode: '62069090',
    Icon: null,
    IconUrl: null,
    SortOrder: 2
  },
  {
    CategoryCode: '2300',
    ParentCategoryCode: '2000',
    Description: 'Children/Baby Clothing',
    TariffCode: '62099090',
    Icon: null,
    IconUrl: null,
    SortOrder: 3
  },
  {
    CategoryCode: '2400',
    ParentCategoryCode: '2000',
    Description: 'Shoes',
    TariffCode: '64059090',
    Icon: null,
    IconUrl: null,
    SortOrder: 4
  },
  {
    CategoryCode: '2500',
    ParentCategoryCode: '2000',
    Description: 'Clothing Accessories',
    TariffCode: '61179000',
    Icon: null,
    IconUrl: null,
    SortOrder: 5
  }
];
const CategorySelection: React.FC<props> = (props) => {
  const [parentCode, setParentCode] = useState<string | null>(null);

  return (
    <P2GFade in>
      <P2GBox>
        {props.children}
        <P2GBox textAlign="center">
          <P2GGrid container spacing={1}>
            {categories
              .filter((x) => x.ParentCategoryCode === parentCode)
              .map((c) => {
                const children = categories.filter((x) => x.ParentCategoryCode === c.CategoryCode);
                const hasChildren = children.length > 0;
                const checked =
                  props.selectedCode === c.TariffCode ||
                  (!parentCode && !!children.find((x) => x.TariffCode == props.selectedCode));
                return parentCode ? (
                  <P2GGrid item xs={6} key={c.Description}>
                    <P2GBox p={1} bordered filled={checked} onClick={() => props.onSelect(c.TariffCode || '')}>
                      <P2GBox>
                        <P2GLink>{c.Description}</P2GLink>
                      </P2GBox>
                    </P2GBox>
                  </P2GGrid>
                ) : (
                  <P2GGrid item xs={3} key={c.Description}>
                    <P2GBox
                      pt={1}
                      pb={1}
                      filled={checked}
                      onClick={() => {
                        if (hasChildren) {
                          setParentCode(c.CategoryCode);
                        } else if (c.TariffCode) {
                          props.onSelect(c.TariffCode);
                        } else {
                          props.exit();
                        }
                      }}
                    >
                      <P2GBox>
                        <P2GConditionalImage style={{ maxWidth: '100%' }} alt={c.Description} src={c.IconUrl || ''} />
                      </P2GBox>
                      <P2GBox>
                        <P2GLink>{c.Description}</P2GLink>
                      </P2GBox>
                    </P2GBox>
                  </P2GGrid>
                );
              })}
          </P2GGrid>
          {!!parentCode && (
            <P2GBox pt={4}>
              <P2GButton onClick={() => setParentCode(null)}>Back</P2GButton>
            </P2GBox>
          )}
        </P2GBox>
      </P2GBox>
    </P2GFade>
  );
};

export { CategorySelection };
